import { render, staticRenderFns } from "./HomeStreak.vue?vue&type=template&id=5123e6ec&scoped=true"
import script from "./HomeStreak.vue?vue&type=script&lang=js"
export * from "./HomeStreak.vue?vue&type=script&lang=js"
import style0 from "./HomeStreak.vue?vue&type=style&index=0&id=5123e6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123e6ec",
  null
  
)

export default component.exports